import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import { CancelFlowMergeField } from '@/store/types';
import { DOMOutputSpec } from 'prosemirror-model';
import MergeFieldView from '@/components/UI/Editor/MergeField/MergeFieldView.vue';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    mergeField: {
      insertMergeField: (options: CancelFlowMergeField) => ReturnType;
    };
  }
}

export default Node.create({
  name: 'mergeField',
  group: 'inline',
  draggable: true,
  atom: true,
  inline: true,
  // content: 'inline*', // This was breaking everything!
  contenteditable: false,
  addAttributes() {
    return {
      id: {
        default: null,
      },
      label: {
        default: null,
      },
      fallback: {
        default: null,
      },
      open: {
        default: false,
      }
    }
  },
  addCommands() {
    return {
      insertMergeField: ({ id, label, fallback }: CancelFlowMergeField) => ({ commands }) => {
        // console.log('Inserting merge field...', { id, label, fallback });
        const type = this.name;
        const attrs = { id, label, fallback };
        return commands.insertContent({
          type,
          attrs,
        });
      }
    }
  },
  parseHTML() {
    return [
      {
        tag: 'merge-field',
        getAttrs: (dom: any) => {
          const result = {
            id: dom.getAttribute('id'),
            label: dom.getAttribute('label'),
            fallback: dom.getAttribute('fallback'),
            open: dom.getAttribute('open'),
          };
          return null;
        },
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const content = `{{${HTMLAttributes.id}|${HTMLAttributes.fallback}}}`; // always include "|fallback", even if fallback is empty!
    return ['merge-field', mergeAttributes(HTMLAttributes), content] as DOMOutputSpec;
  },
  addNodeView() {
    return VueNodeViewRenderer(MergeFieldView);
  },
});
